import React from "react";
import { formatUSD } from "../mock";

// 1st = gold, 2nd = platinum, 3rd = bronze
const medal = {
  1: { label: "First Place", color: "#f5c518" },
  2: { label: "Second Place", color: "#e5e4e2" },
  3: { label: "Third Place", color: "#cd7f32" },
};

const Card = ({ data, elevated }) => {
  if (!data) return null;
  const m = medal[data.rank];
  return (
    <div
      data-testid={`leaderboard-podium-${data.rank}`}
      className={`relative min-w-0 flex flex-col items-center rounded-2xl px-6 pt-14 pb-6 glass transition-transform duration-300 hover:-translate-y-2 ${
        elevated ? "champion-glow -mt-0 md:mb-6 scale-[1.04]" : "glow-ring"
      }`}
    >
      {/* Avatar / rank */}
      <div
        className="absolute -top-9 flex h-[70px] w-[70px] items-center justify-center rounded-full bg-[#0d0f13] ring-2 shadow-xl"
        style={{ "--tw-ring-color": m.color }}
      >
        <img src="/stake-logo.png" alt="Stake" className="h-6 w-auto px-1" />
        <span
          className="absolute -bottom-2 left-1/2 -translate-x-1/2 flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold ring-2 ring-[#0d0f13]"
          style={{ backgroundColor: m.color, color: "#0d0f13" }}
        >
          {data.rank}
        </span>
      </div>

      <span className="text-[11px] uppercase tracking-widest mb-1" style={{ color: m.color }}>
        {m.label}
      </span>
      <h3 data-testid={`leaderboard-podium-player-${data.rank}`} className="max-w-full break-all text-center font-display text-lg font-bold text-white mb-4">
        {data.user}
      </h3>

      <div className="w-full text-center">
        <p className="text-[11px] uppercase tracking-wide text-slate-500">
          Wagered
        </p>
        <p data-testid={`leaderboard-podium-wagered-${data.rank}`} className="break-words text-xl font-semibold text-white tabular-nums">
          {formatUSD(data.wagered)}
        </p>
      </div>

      <div className="mt-4 w-full rounded-xl py-2.5 text-center bg-white/5 ring-1 ring-white/10">
        <span className="text-xs text-slate-400">Prize</span>
        <p data-testid={`leaderboard-podium-prize-${data.rank}`} className="break-words font-display text-lg font-bold" style={{ color: m.color }}>
          {formatUSD(data.prize)}
        </p>
      </div>
    </div>
  );
};

const Podium = ({ topThree }) => {
  const first = topThree.find((t) => t.rank === 1);
  const second = topThree.find((t) => t.rank === 2);
  const third = topThree.find((t) => t.rank === 3);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 items-end max-w-4xl mx-auto">
      <div className="rise" style={{ animationDelay: "0.15s" }}>
        <Card data={second} />
      </div>
      <div className="rise" style={{ animationDelay: "0.05s" }}>
        <Card data={first} elevated />
      </div>
      <div className="rise" style={{ animationDelay: "0.25s" }}>
        <Card data={third} />
      </div>
    </div>
  );
};

export default Podium;
